module.exports = __webpack_public_path__ + "public/images/prizes/arrow-mobile.7d213b342e11c3f81adfb3a3e3cd38a1.svg";